module.exports = {
          srcSet: __webpack_public_path__ + "images/1942-ed814453b351764bd6fb35f647071f1a-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1942-43e802c9fa2f054b7bad16a5d33065f4-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1942-ed814453b351764bd6fb35f647071f1a-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1942-43e802c9fa2f054b7bad16a5d33065f4-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1942-ed814453b351764bd6fb35f647071f1a-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1942-ed814453b351764bd6fb35f647071f1a-320.jpg"},
          
          width: 320,
          height: 251
        }